export const receiptAdded = require("assets/v1.1/icons/Core/ReceiptAdded/receipt-added.svg") + "#outline";
export const fillReceiptAdded = require("assets/v1.1/icons/Core/ReceiptAdded/fill-receipt-added.svg") + "#fill";
